import React, { useState } from "react";
import { HiDotsVertical } from "react-icons/hi";
import { Button, Dropdown, Modal } from "rsuite";
import { FaRegFolderOpen } from "react-icons/fa";
import { MdDriveFileRenameOutline, MdDelete } from "react-icons/md";
import { RiMessage2Line } from "react-icons/ri";
import { useDocuments } from "Pages/Documents/useDocuments";
import ConfirmDeleteModal from "Components/ConfirmDeleteModal/ConfirmDeleteModal";
import styles from "../../Documents.module.css";

function Options({ setEditing, item }) {
  const { handleDelete, openFolder } = useDocuments();

  const [deleting, setDeleting] = useState(false);
  const [showLogs, setShowLogs] = useState(false);

  const openLogs = () => {
    if (!item?.fileId) return;
    setShowLogs(true);
  };

  if (deleting) {
    return (
      <ConfirmDeleteModal
        display={deleting}
        text={`Delete the folder ${item.name} and all its subfolders?`}
        onClose={() => setDeleting(false)}
        onDelete={() => handleDelete(item)}
      />
    );
  }

  const renderButton = (props, ref) => {
    return (
      <div>
        <button className={styles.icon_btn} {...props} ref={ref}>
          <HiDotsVertical />
        </button>
      </div>
    );
  };

  return (
    <>
      <Dropdown renderToggle={renderButton}>
        <Dropdown.Item
          icon={<FaRegFolderOpen style={{ marginRight: 6, paddingTop: 4 }} />}
          onClick={() => {
            if (item.filePath) {
              window.open(item.filePath, "File");
            } else {
              openFolder(item);
            }
          }}
        >
          Open
        </Dropdown.Item>
        {!!item.fileId && (
          <Dropdown.Item
            icon={<RiMessage2Line style={{ marginRight: 6, paddingTop: 4 }} />}
            onClick={openLogs}
          >
            View logs
          </Dropdown.Item>
        )}
        {!item.fileId && (
          <Dropdown.Item
            icon={
              <MdDriveFileRenameOutline
                style={{ marginRight: 6, paddingTop: 4 }}
              />
            }
            onClick={() => setEditing(true)}
          >
            Rename
          </Dropdown.Item>
        )}
        <Dropdown.Item
          icon={<MdDelete style={{ marginRight: 6, paddingTop: 4 }} />}
          onClick={() => setDeleting(true)}
        >
          Delete
        </Dropdown.Item>
      </Dropdown>

      <Modal open={showLogs} onClose={() => setShowLogs(false)} size="sm">
        <Modal.Header>
          <Modal.Title>File stats</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <>
            <div>
              <b>filePath:</b> {item?.filePath || "---"}
            </div>
            <div>
              <b>localStatus:</b> {item?.localStatus || "---"}
            </div>
            <div>
              <b>cloudStatus:</b> {item?.cloudStatus || "---"}
            </div>
            <div>
              <b>failedUploadAttempts:</b> {item?.failedUploadAttempts ?? 0}
            </div>
            <div>
              <b>failedDownloadAttempts:</b> {item?.failedDownloadAttempts ?? 0}
            </div>
            <div style={{ marginTop: 12 }}>
              <b>actionLogs:</b>
              {item?.actionLogs?.length ? (
                <ul style={{ marginTop: 8 }}>
                  {item.actionLogs.map((log, index) => (
                    <li key={index}>
                      {log?.time ? `${log.time} - ` : ""}
                      {log?.user ? `${log.user}: ` : ""}
                      {log?.actionName || JSON.stringify(log)}
                    </li>
                  ))}
                </ul>
              ) : (
                <div>---</div>
              )}
            </div>
          </>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Options;
